/**
 * @notes: Auth endpoints to use for authentication
 */
export const LOGIN_ENDPOINT = "web/users/login";
export const SIGNUP_ENDPOINT = "web/users/signup";
export const SSO_LOGIN_ENDPOINT = "web/users/ssologin";
export const LOGOUT_ENDPOINT = "web/users/logout";
// eslint-disable-next-line sonarjs/no-hardcoded-passwords
export const RECOVER_PASSWORD_ENDPOINT = "web/users/lostpassword";
// eslint-disable-next-line sonarjs/no-hardcoded-passwords
export const CHANGE_PASSWORD_ENDPOINT = "web/users/changepassword";
export const CHECK_UPDATE_ENDPOINT = "versions/check-update";
